import { classNames } from 'lib/utilities'
import PropTypes from 'prop-types'
import React from 'react'
import { Segment } from 'semantic-ui-react'

export default class Loader extends React.Component {
  static propTypes = {
    data: PropTypes.string,
    title: PropTypes.string,
    inactive: PropTypes.bool,
    loading: PropTypes.bool,
  }

  render() {
    const { loading = true, tiny } = this.props

    return (
      <Segment
        attached
        basic
        className={classNames(['placeholder', tiny && 'tiny'])}
        loading={loading}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Helpers/Loader.jsx